export enum LabelType {
    VEHICLE = 1,
    COMPANY = 2
}